module.exports = __webpack_public_path__ + "static/media/laperlesHeader.c9cd61df.png";